import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import store from './store'
import { LanguageProvider } from './i18n/LanguageContext'
import { ThemeModeProvider } from './theme/ThemeModeContext'
import App from './App.jsx'
import './index.css'

const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, '') || '/'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeModeProvider>
        <LanguageProvider>
          <BrowserRouter basename={routerBasename}>
            <App />
            <ToastContainer position="top-right" autoClose={3000} theme="colored" />
          </BrowserRouter>
        </LanguageProvider>
      </ThemeModeProvider>
    </Provider>
  </React.StrictMode>,
)
